export default "__VITE_ASSET__C6Nth_M4__"